import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { DivBackgroundOpacity } from "@utils/extra-style";
import { SalesmanPara } from "../../QuoteList.styled";

const QuotePersonInCharge = (props) => {
  const { t, data } = props;

  return (
    <DivBackgroundOpacity opacity={data.isActive !== 5 ? 1 : "0.2"}>
      <SalesmanPara>
        {data?.sales?.main &&
          data.sales.main.firstName + " " + data.sales.main.lastName}
        {!data?.sales?.main && "-"}

        {data?.sales?.substitutes &&
          data?.sales?.substitutes.map((value, index) => {
            return (
              <span key={index}>
                {", " + `${value.firstName} ${value.lastName}`}
              </span>
            );
          })}
      </SalesmanPara>
    </DivBackgroundOpacity>
  );
};

QuotePersonInCharge.propTypes = {
  t: PropTypes.func.isRequired,
};
export default withTranslation()(QuotePersonInCharge);
